import { gql } from "@apollo/client";

// Same resolver as the legacy GET_VEHICLES_FOR_TRACKING (getTelematicsVehiclesForBusinessCustomer
// in inventory-api/src/resolvers/vehicle.ts) — it already only returns vehicles with an ACTIVE,
// IN_PROGRESS booking schedule for this business customer. This query just asks for the fuller
// field set FleetDashboardV2 needs (make/model/bodyType/vin/fuelType/speed/odometer), matching
// nuvven-b2b-app's GET_TELEMATIC_VEHICLES_PAGED per-vehicle selection. No pagination wrapper —
// the resolver returns a flat list, and a customer's active-booking vehicle list is always small.
export const GET_TRACKED_VEHICLES = gql`
  query getTelematicsVehiclesForBusinessCustomer($businessCustomerId: ID!) {
    getTelematicsVehiclesForBusinessCustomer(businessCustomerId: $businessCustomerId) {
      id
      licencePlate
      make
      model
      bodyType
      vin
      fuelType
      telemetryDeviceId
      teltonikaDeviceId
      immobiliser
      telematicCoreData {
        latitude
        longitude
        eventTime
        speed
        odometer
        address {
          street
          city
        }
      }
      smartCarVehicleData {
        vehicleLocation {
          latitude
          longitude
        }
        odometer {
          distance
        }
        fuelLevel {
          percentRemaining
        }
      }
    }
  }
`;

export const GET_SMART_VEHICLE_DATA = gql`
  query getSmartCarDataForVehicleId($vehicleId: ID!, $trackingHours: Int) {
    getSmartCarDataForVehicleId(vehicleId: $vehicleId, trackingHours: $trackingHours) {
      vehicleId
      odometer {
        distance
      }
      mapRoutesData {
        latlong
        eventTime
      }
      dataAge
    }
  }
`;
